export default __webpack_public_path__ + "static/media/Settings.b52790fc.svg";